export default "__VITE_ASSET__BVqXnS1z__"